module.exports = __webpack_public_path__ + "dist/img/2a.9ce95738.png";